import { queryOptions, useQuery } from '@tanstack/react-query';

import { useStudioStore } from '~entities/studios/model/studio-store';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { StudioFormConfigSummary } from './types';

export const getFormConfigsAPI = async () => {
  const response =
    await baseAPI.get<Array<StudioFormConfigSummary>>('forms/configs');
  return response.data;
};

export const getFormConfigsOptions = (studioId: string | null | undefined) => {
  return queryOptions({
    queryKey: QUERY_KEYS.FORM_CONFIGS(studioId),
    queryFn: () => getFormConfigsAPI(),
  });
};

export const useGetFormConfigs = () => {
  const currentStudioId = useStudioStore((state) => state.currentStudioId);
  return useQuery({
    ...getFormConfigsOptions(currentStudioId),
    enabled: Boolean(currentStudioId),
  });
};
